// this works better as a js file with no type definitions
// because it's generated and it's just a bunch of strings,
// so we have a postbuild script that just copies the esm
// build to index.d.ts and it works great.
var black = "#000000";
var white = "#ffffff";
var transparent = "rgba(0, 0, 0, 0)";
var blue100 = "#f5fbfe";
var blue200 = "#e4f1fb";
var blue300 = "#bfdbee";
var blue400 = "#50c7f9";
var blue500 = "#009cde";
var blue600 = "#0070ba";
var blue700 = "#005ea6";
var blue800 = "#003087";
var grey100 = "#f5f7fa";
var grey200 = "#eaeced";
var grey300 = "#cbd2d6";
var grey400 = "#b7bcbf";
var grey500 = "#9da3a6";
var grey600 = "#687173";
var grey700 = "#2c2e2f";
var green100 = "#f5fdfb";
var green500 = "#00cf92";
var green600 = "#299976";
var green700 = "#018065";
var red100 = "#fff7f7";
var red500 = "#d20000";
var orange100 = "#fffbf5";
var orange300 = "#ffbd5d";
var orange500 = "#ff9600";
var orange700 = "#d64003";
var purple500 = "#640487";
var pink500 = "#de0063";

export { black, white, transparent, blue100, blue200, blue300, blue400, blue500, blue600, blue700, blue800, grey100, grey200, grey300, grey400, grey500, grey600, grey700, green100, green500, green600, green700, red100, red500, orange100, orange300, orange500, orange700, purple500, pink500 };
